"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var AttachmentPreferencesChoiceGroup_1 = require("./AttachmentPreferencesChoiceGroup");
var AttachmentPreferencesFull = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentPreferencesFull, _super);
    function AttachmentPreferencesFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttachmentPreferencesFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var fromComputerSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.fromComputer, userOptions.AttachOrShareLocalFiles);
        var fromOneDriveSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionStore.fromOneDrive, userOptions.AttachOrShareCloudFiles);
        return (React.createElement("div", null,
            React.createElement(AttachmentPreferencesChoiceGroup_1.default, { selectedKey: fromComputerSelectedKey, label: owa_options_strings_1.default.options_attachmentPreferences_localLabel, optionKey: "fromComputer" }),
            React.createElement(AttachmentPreferencesChoiceGroup_1.default, { selectedKey: fromOneDriveSelectedKey, label: owa_options_strings_1.default.options_attachmentPreferences_cloudLabel, optionKey: "fromOneDrive" })));
    };
    AttachmentPreferencesFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
        })
    ], AttachmentPreferencesFull);
    return AttachmentPreferencesFull;
}(React.Component));
exports.default = AttachmentPreferencesFull;
//# sourceMappingURL=AttachmentPreferencesFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/components/AttachmentPreferencesFull.js
// module id = 4980
// module chunks = 2